import React, { useState } from 'react';

type InputProps = {
  refToTextToCopy: any;
};

export const ClickHereToCopy = ({ refToTextToCopy }: InputProps) => {
  const [sourceCopied, setSourceCopied] = useState<boolean>(false);

  const handleCopyClick = () => {
    // IF (11/05/20): This is a little odd but in order to accomplish copying text it needs to be in
    // an input first, so we add one to the dom, copy the text, then remove it.
    const text = refToTextToCopy.current.innerText;
    const input = document.createElement('input');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);

    setSourceCopied(true);
    setTimeout(() => setSourceCopied(false), 1500);
  };

  return (
    <div className="typo-subtitle typo-link" role="presentation" onClick={handleCopyClick}>
      {sourceCopied ? 'Copied!' : 'Click here to copy'}
    </div>
  );
};
